const getters = {
  example: state => state.example,
  statusFilter: state => state.statusFilter
}
export default getters